(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("hci-hospindex-api", [], factory);
	else if(typeof exports === 'object')
		exports["hci-hospindex-api"] = factory();
	else
		root["hci-hospindex-api"] = factory();
})(this, function() {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition